<ng-template #content let-modal>
  <div class="tw-relative tw-w-auto tw-rounded-lg tw-shadow">
    <!-- begin::Modal Header -->
    <div class="tw-rounded-t tw-border-b tw-px-4 tw-py-2.5">
      <div class="tw-flex tw-items-center tw-justify-between">
        <span class="tw-text-[1.0625rem] tw-uppercase tw-text-primary-600">
          {{ headerTitle() }}
        </span>
        <button
          type="button"
          class="tw-ms-auto tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg tw-bg-transparent tw-text-sm tw-text-gray-400 hover:tw-bg-gray-200 hover:tw-text-gray-900 dark:hover:tw-bg-gray-600 dark:hover:tw-text-white"
          appClickStopPropagation
          (click)="modal.dismiss('Cross click')"
        >
          <svg
            class="tw-h-3 tw-w-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- begin::Modal Body -->
    <div #body ngbAutoFocus class="tw-overflow-auto tw-rounded-b-md">
      <form [formGroup]="dataForm">
        <app-lunar-datepicker
          (selected)="onSelect($event)"
          [useRange]="false"
          [fromDate]="dataForm.value.date"
        ></app-lunar-datepicker>
      </form>
    </div>
    <!-- begin::Modal Body -->
  </div>
</ng-template>
